import { render, staticRenderFns } from "./UserDeleteDialog.vue?vue&type=template&id=71cbe257&"
import script from "./UserDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./UserDeleteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UserDeleteDialog.vue"
export default component.exports